import React, { useEffect, useState } from 'react';
import { CreateSupportRegistration, DeleteSupportRegistration } from '../../../api/admin';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { FixedSizeList as List } from 'react-window';
import _MaskedInput from 'react-text-mask';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import LoadingIndicator from '../../../components/Global/loading-indicator/loading-indicator';
import './SupportStaff.scss';
import { useQuery, useMutation } from '@tanstack/react-query';
import Button from '@mui/material/Button';

import {
  Grid,
  Fab,
  Alert,
  CircularProgress,
  FormControl,
  FormHelperText,
  Collapse,
  Chip,
  Box,
  Typography,
} from '@mui/material';

import { DataGrid, gridClasses } from '@mui/x-data-grid';

const MaskedInput = _MaskedInput.default ?? _MaskedInput;

export default function SupportStaff({
  baseProducer,
  codes,
  selectedProducer,
  supportStaff,
  refresh,
  producerIDs,
  isLoading,
  ShowNotificationSnackbar,
}) {
  const [baseProducerOverride, setBaseProducerOverride] = useState(null);
  //const [supportStaff, setSupportStaff] = useState([]);
  // const [producerIDS, setProducerIDS] = useState([]);
  const [overrideProducerIDS, setOverrideProducerIDS] = useState([]);
  //const [filteredSupportStaff, setFilteredSupportStaff] = useState([]);
  const [supportStaffFilter, setSupportStaffFilter] = useState();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [loadingSupportUsers, setLoadingSupportUsers] = useState(false);
  const [tmpProducer, setTmpProducer] = useState(null);

  function DeleteUserModal(ID) {
    if (ID) {
      setSelectedUser({ RegistrationID: ID });
      setShowDeleteModal(true);
    }
  }
  const cancelAdd = () => {
    setShowAddModal(false);
  };
  const cancelDelete = () => {
    setSelectedUser();
    setShowDeleteModal(false);
  };

  const getSupportRegistrationCodes = () => {
    const temp = codes.filter((i) => {
      if (
        i.ProfileName === 'ISD Support Staff with Reporting' ||
        i.ProfileName === 'ISD Support Staff without Reporting' ||
        i.ProfileName === 'ISD Support Staff with Admin' ||
        i.ProfileName === 'SFU Staff Only'
      ) {
        return i;
      }
    });
    return temp;
  };

  const getData = (producerID) => {
    setLoadingSupportUsers(true);
  };

  const userActionsDisabled = () => {
    if (baseProducer !== 'HO') {
      return true;
    }
    return false;
  };

  const renderRow = ({ index }) => (
    <SupportStaffRow
      Key={index}
      ID={supportStaff[index].ID}
      UserID={supportStaff[index].UserID}
      Name={supportStaff[index].DisplayName}
      Email={supportStaff[index].EmailAddress}
      ProducerID={supportStaff[index].ProducerID}
      RegistrationCode={supportStaff[index].RegistrationCode}
      DeleteUserAccount={DeleteUserModal}
    />
  );

  useEffect(() => {
    getData(baseProducerOverride);
  }, [baseProducerOverride]);

  const columns = [
    {
      field: 'displayName',
      headerName: 'Name',
      headerAlign: 'left',
      align: 'left',
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        const chipLabel =
          params.row.userID !== null && params.row.userID
            ? params.row.displayName
            : 'Registration has not been used';

        return (
          <Box>
            <Typography>{chipLabel}</Typography>
          </Box>
        );
      },
    },
    {
      field: 'emailAddress',
      headerName: 'Email',
      headerAlign: 'left',
      align: 'left',
      minWidth: 200,
      flex: 2,
      renderCell: (params) => {
        return params.row.userID !== null && params.row.userID ? (
          <Box>
            <Typography>{params.row.emailAddress}</Typography>
          </Box>
        ) : (
          <Chip variant="outlined" label={'----'} />
        );
      },
    },
    {
      field: 'registrationCode',
      headerName: 'Security Code',
      headerAlign: 'left',
      align: 'left',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'producerID',
      headerName: 'NPN',
      headerAlign: 'left',
      align: 'left',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'details',
      headerName: 'Details',
      type: 'actions',
      headerAlign: 'left',
      align: 'left',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const details = params.formattedValue ? JSON.parse(params.formattedValue) : {};
        details.id = params.row.id ? params.row.id : 0;
        return (
          <Fab
            size="small"
            color="secondary"
            aria-label="Delete Support User"
            onClick={() => {
              DeleteUserModal(params.row.id);
            }}
          >
            <DeleteForeverIcon />
          </Fab>
        );
      },
    },
  ];

  const rows = supportStaff?.map((s, index) => ({
    id: s.id,
    userID: s.userID,
    displayName: s.displayName,
    emailAddress: s.emailAddress,
    producerID: s.producerID,
    registrationCode: s.registrationCode,
    rowIndex: index,
  }));

  return (
    <div className="pt-4" id="support-staff">
      <div className="col-12 pb-4" id="support-user-actions">
        <div>
          <Button
            style={{
              backgroundColor: '#1976d2',
              padding: '0.5em 2em',
              fontSize: 'medium',
              color: 'white',
            }}
            variant="contained"
            onClick={() => {
              setShowAddModal(true);
            }}
          >
            Add User Registration
          </Button>
        </div>
      </div>
      <Grid sx={{ width: '100%' }}>
        {supportStaff && (
          <>
            <DataGrid
              sx={{
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: 'transparent',
                },
                '& .MuiDataGrid-row.Mui-hovered': {
                  backgroundColor: 'transparent',
                },
                '& p': {
                  margin: 0,
                },
                '& .MuiTablePagination-actions': {
                  marginTop: 0,
                },
                [`& .${gridClasses.columnHeader}, & .${gridClasses.cell}`]: {
                  outline: 'transparent',
                },
                [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]:
                  {
                    outline: 'none',
                  },
                height: 600,
              }}
              rows={rows}
              columns={columns}
              disableRowSelectionOnClick
              disableColumnSelector
              loading={!supportStaff || !overrideProducerIDS}
              slotProps={{
                loadingOverlay: {
                  variant: 'skeleton',
                },
              }}
            />
          </>
        )}
      </Grid>

      <DeleteSupportStaffModal
        show={showDeleteModal}
        selectedUser={selectedUser}
        refresh={refresh}
        close={cancelDelete}
        ShowNotificationSnackbar={ShowNotificationSnackbar}
      />
      <AddSupportStaffModal
        show={showAddModal}
        registrationCodes={getSupportRegistrationCodes()}
        usedIDs={
          supportStaff !== null && supportStaff.length > 0
            ? supportStaff.map((i, index) => i.producerID.trim())
            : []
        }
        refresh={refresh}
        close={cancelAdd}
        npnID={selectedProducer != null ? selectedProducer.avX_NPN : null}
        printName={selectedProducer != null ? selectedProducer.printName : ''}
        ShowNotificationSnackbar={ShowNotificationSnackbar}
      />
    </div>
  );
}

function AddSupportStaffModal({
  show,
  producerIDS,
  registrationCodes,
  usedIDs,
  refresh,
  close,
  npnID,
  printName,
  ShowNotificationSnackbar,
}) {
  const [progress, setProgress] = useState();
  const [base, setBase] = useState();
  const [suffix, setSuffix] = useState();
  const [usedID, setUsedID] = useState(false);
  const [code, setCode] = useState();
  const [submitDisabled, setSubmitDisabled] = useState(true);

  function suffixInfo() {
    return (
      <div>
        Suffix must be <span style={{ fontWeight: 'bold' }}>2 letters only</span>.
      </div>
    );
  }

  const createSupportReg = useMutation(
    (data) => {
      let create = CreateSupportRegistration(data);
      create()
        .then((response) => {
          setProgress('success');
          refresh();
          ShowNotificationSnackbar('', 'Add Support Staff Successful', 'success');
        })
        .catch((error) => {
          console.log(error);
          setProgress('failure');
          ShowNotificationSnackbar('Support Staff Error', '', 'error');
        });
    } /*, {
        onSuccess: () => {
            setProgress('success');
            refresh();
        },
        onError: (err) => {
            console.log(err);
            setProgress('failure');
        }*/
  );

  const addUserToDB = () => {
    const body = {
      ProducerID: base,
      ProducerIDSuffix: suffix,
      RegistrationCode: code,
    };
    setProgress('loading');

    createSupportReg.mutate(body, {
      onSuccess: () => {
        setProgress('success');
        refresh();
      },
      onError: (error) => {
        console.log(error);
        setProgress('failure');
      },
    });
  };

  const isDisabled = () => {
    if (progress === 'loading') {
      return true;
    }
    return false;
  };

  const validateFields = () => {
    if (
      base != null &&
      suffix != null &&
      code != null &&
      npnID !== 'HO' &&
      npnID !== 'undefined' &&
      npnID !== null
    ) {
      return true;
    }
    return false;
  };

  const userID = () => {
    if (base != null && base != 'undefined' && suffix != null && suffix != 'undefined')
      return base.trim() + suffix.trim(); //get rid of whitespace

    return base + suffix;
  };

  const checkUsed = () => {
    if (usedIDs.includes(userID())) {
      setUsedID(true);
      return true;
    }
    setUsedID(false);
    return false;
  };

  useEffect(() => {
    if (show) {
      setProgress();
    }
    if (npnID !== 'HO' && npnID !== 'undefined' && npnID !== null) setBase(npnID);
    else setBase();
    setSuffix();
    setCode();
  }, [show]);

  useEffect(() => {
    if (checkUsed() || !validateFields() || isDisabled()) {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }
  }, [base, suffix, code]);

  const bodyElements = [];
  const footerElements = [];

  if (progress == null) {
    bodyElements.push(
      <>
        <div id="producer-suffix-entry" key="producer-suffix-entry">
          <div id="producerid-select">
            <label>Producer Selected: {printName}</label>
          </div>
          <div key="suffix">
            <FormControl>
              <MaskedInput
                className="masked-input"
                mask={[/[a-zA-Z0-9]/, /[a-zA-Z0-9]/]}
                placeholder="XX"
                id="support-producerid-suffix"
                onChange={(e) => {
                  e.target.value = e.target.value.replace('_', '').toUpperCase();
                  if (e.target.value.replace('_', '').length === 2) {
                    setSuffix(e.target.value);
                  } else {
                    setSuffix();
                  }
                }}
                onBlur={(e) => {
                  if (e.target.value.replace('_', '').length !== 2) {
                    e.target.value = '';
                  }
                }}
              />
              <FormHelperText>Producer Suffix</FormHelperText>
            </FormControl>
          </div>
        </div>
        <div key="registration-select">
          <Autocomplete
            id="producerid-select"
            options={registrationCodes.sort().map((i) => ({ value: i.Code, label: i.ProfileName }))}
            getOptionLabel={(option) => option.label}
            onChange={(_, val) => {
              setCode(val ? val.value : undefined);
            }}
            renderInput={(params) => <TextField {...params} placeholder="Registration Code" />}
          />
        </div>
      </>
    );

    footerElements.push(
      <>
        <button
          type="button"
          key="submit"
          className="btn btn-success"
          disabled={submitDisabled}
          onClick={() => {
            addUserToDB();
          }}
        >
          Add User
        </button>
      </>
    );
  }

  if (progress === 'loading') {
    bodyElements.push(<CircularProgress />);
  }
  if (progress === 'success') {
    bodyElements.push(<>User registration was succesfully added.</>);
  }
  if (progress === 'failure') {
    bodyElements.push(<>Failed to create user registration. Would you like to try again?</>);
    footerElements.push(
      <>
        <button
          type="button"
          key="retry"
          className="btn btn-success"
          disabled={isDisabled()}
          onClick={() => {
            addUserToDB();
          }}
        >
          Retry
        </button>
      </>
    );
  }

  return (
    <Dialog
      style={{ margin: '10% 0' }}
      open={show}
      onClose={() => {
        close();
      }}
    >
      <DialogTitle>
        <div>Add Support User Registration</div>
      </DialogTitle>
      <DialogContent id="add-user-modal-body">
        <Alert severity="warning" color="warning" style={{ backgroundColor: 'rgb(255, 244, 229)' }}>
          {suffixInfo()}
        </Alert>
        {bodyElements}
        <div className="pt-3">
          <Collapse in={usedID}>
            <Alert severity="error">
              This Producer ID and Suffix combination has already been used.
            </Alert>
          </Collapse>
        </div>
      </DialogContent>
      <DialogActions>
        {footerElements}
        <button
          type="button"
          className="btn btn-danger"
          disabled={isDisabled()}
          onClick={() => {
            close();
          }}
        >
          {!progress || progress === 'loading' || progress === 'failure' ? <>Cancel</> : <>Close</>}
        </button>
      </DialogActions>
    </Dialog>
  );
}

function DeleteSupportStaffModal({ show, selectedUser, refresh, close, ShowNotificationSnackbar }) {
  const [progress, setProgress] = useState();

  const deleteSupportReg = useMutation({
    mutationFn: async () =>
      await DeleteSupportRegistration({
        RegistrationID: selectedUser.RegistrationID,
        UserID: null,
      })(),
  });

  const deleteUserSupportRegFromDB = () => {
    setProgress('loading');
    deleteSupportReg.mutate(undefined, {
      onSuccess: () => {
        setProgress('success');
        refresh();
      },
      onError: (error) => {
        console.log(error);
        setProgress('failure');
      },
    });
  };

  const isDisabled = () => {
    if (progress === 'loading') {
      return true;
    }
    return false;
  };
  const bodyElements = [];
  const footerElements = [];

  useEffect(() => {
    if (show === true) {
      setProgress();
    }
  }, [show]);

  if (progress == null) {
    bodyElements.push(<>Are you sure you want to delete this support staff user?</>);
    footerElements.push(
      <>
        <button
          type="button"
          className="btn btn-success"
          disabled={isDisabled()}
          onClick={() => {
            deleteUserSupportRegFromDB();
          }}
        >
          Delete User
        </button>
      </>
    );
  }

  if (progress === 'loading') {
    bodyElements.push(<CircularProgress key={'loading-indicator'} />);
  }
  if (progress === 'success') {
    bodyElements.push(<>User was successfully deleted.</>);
  }
  if (progress === 'failure') {
    bodyElements.push(<>User was not successfully deleted. Would you like to try again?</>);
    footerElements.push(
      <>
        <button
          type="button"
          className="btn btn-success"
          disabled={isDisabled()}
          onClick={() => {
            deleteUserSupportRegFromDB();
          }}
        >
          Retry
        </button>
      </>
    );
  }

  return (
    <Dialog
      style={{ margin: '10% 0' }}
      open={show}
      onClose={() => {
        close();
      }}
    >
      <DialogTitle>
        <div>Delete User?</div>
      </DialogTitle>
      <DialogContent>{bodyElements}</DialogContent>
      <DialogActions>
        {footerElements}
        <button
          type="button"
          className="btn btn-danger"
          disabled={isDisabled()}
          onClick={() => {
            close();
          }}
        >
          {!progress || progress === 'loading' || progress === 'failure' ? <>Cancel</> : <>Close</>}
        </button>
      </DialogActions>
    </Dialog>
  );
}
